import React from 'react'
import styled from 'styled-components'
import Div from '@jarvis.oddle/core/components/Div'
import {
  iconSizes,
  margin,
  marginSizes
} from '@jarvis.oddle/core/theme/default'
import IconFacebook from '@jarvis.oddle/core/components/Icons/IconFacebook'
import IconInstagram from '@jarvis.oddle/core/components/Icons/IconInstagram'
import IconTwitter from '@jarvis.oddle/core/components/Icons/IconTwitter'
import IconYoutube from '@jarvis.oddle/core/components/Icons/IconYoutube'
import { H3 } from '@jarvis.oddle/core/components/Typo'
import { parserHref } from 'tools/routes'

const IconContainer = styled.a`
  margin-right: ${margin[marginSizes.medium]};
`

const SocialMedia = ({
  settings
}: {
  settings: {
    headingsText: string
    facebookUrl: string
    instagramUrl: string
    twitterUrl: string
    youtubeUrl: string
  }
}): JSX.Element => (
  <Div>
    <H3 normalised bold>
      {settings.headingsText}
    </H3>
    <Div marginTop={marginSizes.small}>
      {settings.facebookUrl && (
        <IconContainer target='_blank' href={parserHref(settings.facebookUrl)}>
          <IconFacebook iconSize={iconSizes.large} />
        </IconContainer>
      )}
      {settings.instagramUrl && (
        <IconContainer target='_blank' href={parserHref(settings.instagramUrl)}>
          <IconInstagram iconSize={iconSizes.large} />
        </IconContainer>
      )}
      {settings.twitterUrl && (
        <IconContainer target='_blank' href={parserHref(settings.twitterUrl)}>
          <IconTwitter iconSize={iconSizes.large} />
        </IconContainer>
      )}
      {settings.youtubeUrl && (
        <IconContainer target='_blank' href={parserHref(settings.youtubeUrl)}>
          <IconYoutube iconSize={iconSizes.large} />
        </IconContainer>
      )}
    </Div>
  </Div>
)

export default SocialMedia
